import React, { createContext, useContext, useState, useCallback } from 'react';

const envDefault = import.meta.env.VITE_MVP_MODE === 'true';

const MvpContext = createContext({ isMvpMode: envDefault, toggleMvp: () => {} });

export function MvpProvider({ children }) {
  const [isMvpMode, setIsMvpMode] = useState(() => {
    const stored = sessionStorage.getItem('mvp_override');
    return stored !== null ? stored === 'true' : envDefault;
  });

  const toggleMvp = useCallback(() => {
    setIsMvpMode(prev => {
      const next = !prev;
      sessionStorage.setItem('mvp_override', String(next));
      return next;
    });
  }, []);

  return (
    <MvpContext.Provider value={{ isMvpMode, toggleMvp }}>
      {children}
    </MvpContext.Provider>
  );
}

export function useMvpMode() {
  return useContext(MvpContext);
}

export const isMvpMode = envDefault;
